export default __webpack_public_path__ + "static/smp-in-meshery-27f935b7a77dca2563cab4a655b1c512.png";